import { call, put, takeEvery } from "redux-saga/effects";
import {
  addFleetApi,
  getMasterAccountReportApi,
  getFastagVehicleReportApi,
  updateFleetApi,
  advancedVehicleListApi,
  saveVehicleProfileApi,
  editVehicleProfileApi,
  getVehicleProfileApi,
  getKarzaVehicleDataApi,
  getServiceHistoryApi,
  getServiceItemsApi,
  addServiceItemsApi,
  deleteServiceHistoryApi,
  saveKarzaVehicleApi,
  updateKarzaVehicleApi,
  getAnalyticalDataApi,
  getGpsStatusApi,
  connectGpsApi,
  getGpsListApi,
  getGpsLastLocationApi,
  getGpsComputedVehicleApi,
  downloadVehicleLedgerApi,
  uplaodTollTxnApi
} from "../../Utils/Apis";
import {
  addFleetSuccess,
  getMasterAccountStatementSuccess,
  getFastagVehicleHistoryStatementSuccess,
  updateFleetSuccess,
  advancedVehicleListSuccess,
  saveVehicleProfileDataSuccess,
  editVehicleProfileDataSuccess,
  getVehicleProfileDataSuccess,
  clearVehicleProfileData,
  clearKarzaVehicleData,
  getKarzaVehicleDataSuccess,
  getServiceHistorySuccess,
  deleteServiceHistorySuccess,
  addServiceItemsSuccess,
  getServiceItemsSuccess,
  saveKarzaVehicleSuccess,
  updateKarzaVehicleSuccess,
  getAnalyticalDataSuccess,
  gpsConnectSuccess,
  getGpsDataSuccess,
  getGpsStatusSuccess,
  getGpsLastLocationSuccess,
  getGpsComputedDataSuccess,
  ddownloadVehicleLedgerSuccessAction,
  uplaodTollTxnSuccess,
} from "../Actions/fleetActions";
import {
  ADD_FLEET,
  GENERATE_MASTER_ACCOUNT_STATEMENT,
  GENERATE_FASTAG_VEHICLE_STATEMENT,
  UPDATE_FLEET,
  ADVANCED_VEHICLE_LIST,
  SAVE_VEHICLE_PROFILE_DATA,
  EDIT_VEHICLE_PROFILE_DATA,
  GET_VEHICLE_PROFILE_DATA,
  GET_KARZA_VEHICLE_DATA,
  GET_SERVICE_HISTORY,
  DELETE_SERVICE_HISTORY,
  GET_SERVICE_ITEMS,
  ADD_SERVICE_ITEMS,
  SAVE_KARZA_VEHICLE,
  UPDATE_KARZA_VEHICLE,
  GET_FLEET_ANALYTICS,
  GET_GPS_STATUS,
  GPS_CONNECT,
  GET_GPS_DATA,
  LAST_LOCATION,
  GPS_COMPUTED_VEHICLE_DATA,
  DOWNLOAD_VEHICLE_LEDGER,
  UPLOAD_TOLL_TXN,
} from "../storeTypes";
import { processErrorAndRespond } from "../../Utils/functions";
import {
  toastStatus,
  toastStatusSuccess,
} from "../../../services/Store/Actions/appActions";

function* addFleetsaga(action) {
  try {
    const response = yield call(addFleetApi, action.payload);
    console.log("addFleetsaga", response?.data);
    if (response?.data?.type == "success") {
      action.callBack(response?.data);
      console.log("step-1");
      yield put(addFleetSuccess(response.data?.data));
      console.log("step-2");
      yield put(
        toastStatus({
          toastStatus: true,
          message: response?.data?.message || "New vehicle was added successfully",
          status: true,
          toggleModal : action?.toggleModalToast,
          handleClose : action?.handleCloseToast
        })
      );
    }
  } catch (error) {
    yield put(addFleetSuccess())
    yield put(
      
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "Error" ,
        status: false,
        toggleModal : action?.toggleModalToast,
        handleClose : action?.handleCloseToast
      })
    );
  
    // if (error.response?.status == 401) {
    //    yield put(
    //   toastStatus({
    //   toastStatus: true,
    //   message: `Error : ${error?.response?.data?.message}`,
    //   status: false,
    // }));
    //   action.callBack(error.response?.data?.message);
    // } else if (error?.response?.status == 400) {
    //   action.callBack({
    //     message: error?.response?.data.message,
    //   });
    // } else {
    //   action.callBack(error?.response?.data?.error);
    //   alert(`error :${error?.response?.data?.message} `);

    // }
    //console.log(typeof error.response?.status);
    //ToastAndroid.show(error?.response?.data.message, ToastAndroid.SHORT);
    console.log("Error.Response addFleetsaga:- ", error);
    // console.log('API Error:- ', processErrorAndRespond(error));
  }
}

function* saveKarzaVehicleSaga(action){
  try{
    const response = yield call(saveKarzaVehicleApi, action?.payload)
    console.log('response',response?.data);
    if(response?.data?.type == 'success'){
      action?.callBack(response?.data)
      yield put(saveKarzaVehicleSuccess());
    }
  }
  catch(error){
    console.log('saveKarzaVehicleSaga error=>',error?.response?.data);
    yield put(
      
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "Error" ,
        status: false,
        toggleModal : action?.toggleModalToast,
        handleClose : action?.handleCloseToast
      })
    );
  }
}
function* updateKarzaVehicleSaga(action){
  try{
    console.log("updateKarzaVehicleSagasssss",action)
    const response = yield call(updateKarzaVehicleApi, action?.payload)
    console.log('response',response?.data);
    if(response?.data?.type == 'success'){
      action?.callBack(response?.data)
      yield put(saveKarzaVehicleSuccess());
    }
  }
  catch(error){
    console.log('saveKarzaVehicleSaga error=>',error?.response?.data);
    yield put(
      
      toastStatus({
        toastStatus: true,
        message: error?.response?.data?.message || "Error" ,
        status: false,
        toggleModal : action?.toggleModalToast,
        handleClose : action?.handleCloseToast
      })
    );
  }
}


function* getGpsStatusSaga(action){
  try{
    console.log("getGpsStatusSagagetGpsStatusSagagetGpsStatusSaga",action)
    const response = yield call(getGpsStatusApi, action?.payload)
    console.log('responsegetGpsStatusSaga',response?.data);
    if(response?.data?.type == 'success'){
      action?.callBack(response?.data)
      yield put(getGpsStatusSuccess(response?.data));
    }
  }
  catch(error){
    console.log('getGpsStatusSaga error=>',error?.response?.data);
  }
}

function* gpsConnectSaga(action){
  try{
    console.log("gpsConnectSagagpsConnectSagagpsConnectSaga",action)
    const response = yield call(connectGpsApi, action?.payload)
    console.log('responsegpsConnectSaga',response);
    if(response?.data?.type == 'success'){
      action?.callBack(response?.data)
      yield put(gpsConnectSuccess());
    }
  }
  catch(error){
    console.log('saveKarzaVehicleSaga error=>gpsConnectSaga',error?.response?.data);
    
  }
}

function* getGpsListSaga(action){
  try{
    console.log("getGpsListSagagetGpsListSagagetGpsListSaga",action)
    const response = yield call(getGpsListApi, action?.payload)
    console.log('responsegetGpsListSagagetGpsListSaga',response?.data);
    if(response?.data?.type == 'success'){
      action?.callBack(response?.data)
      yield put(getGpsDataSuccess(response?.data?.data || response?.data));
    }
  }
  catch(error){
    console.log('getGpsListSaga error=>',error?.response?.data);
    
  }
}

function* getGpsLastLocationSaga(action){
  try{
    console.log("getGpsLastLocationApigetGpsLastLocationApi",action)
    const response = yield call(getGpsLastLocationApi, action?.payload)
    console.log('getGpsLastLocationApigetGpsLastLocationApiResponse',response?.data);
    if(response?.data?.type == 'success'){
      action?.callBack(response?.data)
      yield put(getGpsLastLocationSuccess(response?.data));
    }
  }
  catch(error){
    console.log('getGpsListSaga error=>',error?.response?.data);
    
  }
}

function* getGpsComputedListSaga(action){
  try{
    console.log("getGpsComputedVehicleApigetGpsComputedVehicleApi",action)
    const response = yield call(getGpsComputedVehicleApi, action?.payload)
    console.log('responsegetGpsComputedVehicleApi',response?.data);
    if(response?.data?.type == 'success'){
      action?.callBack(response?.data)
      yield put(getGpsComputedDataSuccess(response?.data));
    }
  }
  catch(error){
    console.log('getGpsListSaga error=>',error?.response?.data);
    
  }
}

function* getMasterAccountReportSaga(action) {
  try {
    const response = yield call(getMasterAccountReportApi, action.payload);
    console.log("saga-> fleet-- ", response);
    if (response.data.type == "success") {
      action.callback(response);
      console.log('DATA123',response?.data)
      let status = response?.data?.data? true: false
      yield put(getMasterAccountStatementSuccess(response?.data?.data));

      yield put(
        toastStatus({
          toastStatus: true,
          message: response?.data?.message,
          status: status,
        }))
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response.data);
    //Alert.alert('Error', error.response.data.message);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}
function* getFastagVehicleReportSaga(action) {
  try {
    const response = yield call(
      getFastagVehicleReportApi,
      action.userId,
      action.payload
    );
    console.log("saga-> fleet-- ", response?.data);
    if (response.data.type == "success") {
      action.callback(response);
      yield put(getFastagVehicleHistoryStatementSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response.data);
    //Alert.alert('Error', error.response.data.message);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}
function* updateFleetSaga(action) {
  try {
    const response = yield call(
      updateFleetApi,
      action.payload
    );
    console.log("updateFleetSaga response",response);
    if (response.data.type == "success") {
      action.callBack(response);
      yield put(updateFleetSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response.data);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}
function* advancedVehicleListSaga(action){
  try{
    const response = yield call(advancedVehicleListApi,action?.payload)
    console.log('ADVANCEDVEHICLELIST',response?.data)
    if(response?.data?.type == 'success'){
      yield put(advancedVehicleListSuccess(response?.data?.data))
    }
  }
  catch(error){
    console.log('ERRORADVAPI',error)

  }
}

function* saveVehicleProfileSaga(action) {
  try {
    const response = yield call(
      saveVehicleProfileApi,
      action.payload
    );
    console.log("saveVehicleProfileSaga response",response);
    if (response.data.type == "success") {
      action.callBack(response);
      yield put(saveVehicleProfileDataSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response.data);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* editVehicleProfileSaga(action) {
  try {
    const response = yield call(
      editVehicleProfileApi,
      action.payload
    );
    console.log("editVehicleProfileSaga response",response);
    if (response.data.type == "success") {
      action.callBack(response);
      yield put(editVehicleProfileDataSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error?.response);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* getVehicleProfileSaga(action) {
  try {
    const response = yield call(
      getVehicleProfileApi,
      action.payload
    );
    console.log("getVehicleProfileSaga response",response);
    if (response.data.type == "success") {
      action.callBack(response);
      yield put(clearVehicleProfileData());
      yield put(getVehicleProfileDataSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response?.data);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}
function* getKarzaVehicleDataSaga(action) {
  try {
    const response = yield call(
      getKarzaVehicleDataApi,
      action.payload
    );
    console.log("getKarzaVehicleDataSaga response",response);
    if (response.data.type == "success") {
      yield put(getKarzaVehicleDataSuccess(response?.data?.data));
    }
  } catch (error) {
    yield put(clearKarzaVehicleData());
    console.log("Error.Response:- ", error.response?.data);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}
function* getServiceHistorySaga(action) {
  try {
    const response = yield call(
      getServiceHistoryApi,
      action.payload
    );
    console.log("getKarzaVehicleDataSaga response",response);
    if (response.data.type == "success") {
      action.callBack(response);
      yield put(getServiceHistorySuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response?.data);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* deleteServiceHistorySaga(action) {
  try {
    const response = yield call(
      deleteServiceHistoryApi,
      action.payload
    );
    console.log("getKarzaVehicleDataSaga response",response);
    if (response.data.type == "success") {
      action.callBack(response);
      yield put(deleteServiceHistorySuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response?.data);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* getServiceItemsSaga(action) {
  try {
    const response = yield call(
      getServiceItemsApi,
      action.payload
    );
    console.log("getKarzaVehicleDataSaga response",response);
    if (response.data.type == "success") {
      action.callBack(response);
      yield put(getServiceItemsSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response?.data);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* addServiceItemsSaga(action) {
  try {
    const response = yield call(
      addServiceItemsApi,
      action.payload
    );
    console.log("getKarzaVehicleDataSaga response",response);
    if (response.data.type == "success") {
      action.callBack(response);
      yield put(addServiceItemsSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response?.data);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* getAnalyticalDataSaga(action) {
  try {
    console.log("GET_FLEET_ANALYTICS",action);
    const response = yield call(
      getAnalyticalDataApi,
      action.payload
      );
      console.log("GET_FLEET_ANALYTICS",response);
    if (response.data.type == "success") {
      action.callBack(response);
      yield put(getAnalyticalDataSuccess(response?.data?.data));
    }
  } catch (error) {
    console.log("Error.Response:- ", error.response?.data);
    console.log("API Error:- ", processErrorAndRespond(error));
    action.callBack(error?.response);

  }
}

function* downloadVehilcleLedgerSaga(action) {
  try {
    const response = yield call(downloadVehicleLedgerApi, action?.fleetId,action?.payload);
    action.callBack(response);
    if (response?.data?.type == "success") {
      yield put(ddownloadVehicleLedgerSuccessAction());
    }
  } catch (error) {
    action.callBack(error.response);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

function* uplaodTollTxnSaga(action) {
  try {
    console.log("saga aaya");
    const response = yield call(uplaodTollTxnApi, action.payload);
    // if (response.type == "success") {
      action.callBack(response);
      yield put( uplaodTollTxnSuccess(response));
    // }
  } catch (error) {
    //console.log('Error.Response:- ', error.response.data);
    //Alert.alert('Error', error.response.data.message);
    action.callBack(error?.response);
    console.log("API Error:- ", processErrorAndRespond(error));
  }
}

export function* watchFleetSagas() {
  yield takeEvery(ADD_FLEET, addFleetsaga);
  yield takeEvery(SAVE_KARZA_VEHICLE,saveKarzaVehicleSaga);
  yield takeEvery(UPDATE_KARZA_VEHICLE, updateKarzaVehicleSaga);
  yield takeEvery(GET_GPS_STATUS, getGpsStatusSaga);
  yield takeEvery(GPS_CONNECT, gpsConnectSaga);
  yield takeEvery(GET_GPS_DATA, getGpsListSaga);
  yield takeEvery(LAST_LOCATION, getGpsLastLocationSaga);
  yield takeEvery(GPS_COMPUTED_VEHICLE_DATA, getGpsComputedListSaga);
  yield takeEvery(
    GENERATE_MASTER_ACCOUNT_STATEMENT,
    getMasterAccountReportSaga
  );
  yield takeEvery(
    GENERATE_FASTAG_VEHICLE_STATEMENT,
    getFastagVehicleReportSaga
  );
  yield takeEvery(UPDATE_FLEET, updateFleetSaga);
  yield takeEvery(ADVANCED_VEHICLE_LIST,advancedVehicleListSaga)
  yield takeEvery(SAVE_VEHICLE_PROFILE_DATA,saveVehicleProfileSaga)
  yield takeEvery(EDIT_VEHICLE_PROFILE_DATA,editVehicleProfileSaga)
  yield takeEvery(GET_VEHICLE_PROFILE_DATA,getVehicleProfileSaga)
  yield takeEvery(GET_KARZA_VEHICLE_DATA,getKarzaVehicleDataSaga)
  yield takeEvery(GET_SERVICE_HISTORY,getServiceHistorySaga)
  yield takeEvery(DELETE_SERVICE_HISTORY,deleteServiceHistorySaga)
  yield takeEvery(GET_SERVICE_ITEMS,getServiceItemsSaga)
  yield takeEvery(ADD_SERVICE_ITEMS,addServiceItemsSaga)
  yield takeEvery(GET_FLEET_ANALYTICS,getAnalyticalDataSaga)
  yield takeEvery(DOWNLOAD_VEHICLE_LEDGER, downloadVehilcleLedgerSaga);
  yield takeEvery(UPLOAD_TOLL_TXN, uplaodTollTxnSaga);
}
